define("logging/XMLUtility", [
    'chemistry/Solution',
    'models/Vessel',
    'models/Tool'
], function (Solution, VesselModel, ToolModel) {
    var instance = null;
    function XMLUtility () {
        
    };
    XMLUtility.prototype.xmlComponent = function (component) {
        var array = [];
        if (component instanceof VesselModel) {
            array.push(
                "<component type=\"FLASK\">\n",
                "\t<id>" + component.cid + "</id>\n",
                this.tabify(this.xmlFlask(component)).join(""),
                "</component>\n"
            );
            return array;
        }
        else if (component instanceof ToolModel) {
            if (component.get("tool").name === "Scale") {
                array.push(
                    "<component type=\"SCALE\">\n",
                    "\t<id>" + component.cid + "</id>\n",
                    this.tabify(this.xmlScale(component)).join(""),
                    "</component>\n"
                );
                return array;
            }
            else if (component.get("tool").name === "Bunsen_Burner") {
                array.push(
                    "<component type=\"BURNER\">\n",
                    "\t<id>" + component.cid + "</id>\n",
                    this.tabify(this.xmlBurner(component)).join(""),
                    "</component>\n"
                );
                return array;
            }
        }
        array.push(
            "<component type=\"OTHER\">\n",
            "\t<id>" + component.cid + "<id>\n",
            "</component>\n"
        );
        return array;
    };
    XMLUtility.prototype.xmlFlask = function (object) {
        var solution, vessel;
        if (object instanceof Solution) {
            solution = object;
            vessel = object.container;
        }
        else if (object instanceof VesselModel) {
            solution = object.get("solution");
            vessel = object;
        }
        else {
            return [];
        }
        var array = [];
        array.push(
            "<flask>\n",
            "\t<id>" + vessel.cid + "</id>\n",
            "\t<source>" + vessel.get("origin") + "</source>\n",
            "\t<name><![CDATA[" + solution.name + "]]></name>\n",
            "\t<temp scale=\"K\">" + solution.getTemperature() + "</temp>\n",
            "\t<volume units=\"L\">" + solution.getVolume() + "</volume>\n",
            "\t<vessel>\n",
            "\t\t<type>" + vessel.get("vessel").name + "</type>\n",
            "\t\t<volume units=\"L\">" + vessel.get("vessel").maxVolume + "</volume>\n",
            "\t</vessel>\n"
        );
        var index;
        for (index = 0; index < solution.getSpeciesCount(); index++) {
            var speciesNode = solution.getSpeciesAt(index);
            array.push(this.tabify(this.xmlSpecies(speciesNode)).join(""));
        }
        array.push("</flask>\n");
        return array;
    };
    XMLUtility.prototype.xmlSpecies = function (species) {
        var array = [];
        array.push(
            "<species>\n",
            "\t<id>" + species.archetype.id + "</id>\n",
            "\t<name><![CDATA[" + species.archetype.name + "]]></name>\n",
            "\t<moles>" + species.moles + "</moles>\n",
            this.tabify(this.xmlMass(species.getWeight())).join(""),
            "\t<state>" + species.archetype.state + "</state>\n",
            "</species>\n"
        );
        return array;
    };
    XMLUtility.prototype.oldLoggingFormat = function (solution) {
        var str = "(";
        var index;
        for (index = 0; index < solution.getSpeciesCount(); index++) {
            var speciesNode = solution.getSpeciesAt(index);
            if (index !== 0) {
                if (speciesNode.getConcentration() === 0) {
                    str += ", " + speciesNode.getWeight() + "g of " + speciesNode.archetype.name;
                }
                else {
                    str += ", " + speciesNode.getConcentration() + "M of " + speciesNode.archetype.name;
                }
            }
            else {
                if (speciesNode.getConcentration() === 0) {
                    str += speciesNode.getWeight() + "g of " + speciesNode.archetype.name;
                }
                else {
                    str += speciesNode.getConcentration() + "M of " + speciesNode.archetype.name;
                }
            }
        }
        if (solution.getSpeciesCount() !== 0) {
            str += "; " + "V=" + (solution.getVolume() * 1000) + " mL," + "T=" + solution.getTemperature() + "K)";
        }
        else {
            str += "V=" + (solution.getVolume() * 1000) + " mL," + "T=" + solution.getTemperature() + "K)";
        }
        return str;
    };
    XMLUtility.prototype.xmlMass = function (mass) {
        var array = [];
        array.push("<mass units=\"g\">" + mass + "</mass>\n");
        return array;
    };
    XMLUtility.prototype.xmlScale = function (scale) {
        var array = [];
        array.push(
            "<scale>\n",
            "\t<id>" + scale.cid + "</id>\n",
            "\t<reading units=\"g\">" + scale.get("weight") + "</reading>\n",
            "</scale>\n"
        );
        return array;
    };
    XMLUtility.prototype.xmlBurner = function (burner) {
        var array = [];
        array.push(
            "<burner>\n",
            "\t<id>" + burner.cid + "</id>\n",
            "</burner>\n"
        );
        return array;
    };
    XMLUtility.prototype.xmlWorkbench = function (workbench) {
        var array = [];
        array.push(
            "<workbench>\n",
            "\t<id>" + workbench.cid + "</id>\n",
            "</workbench>\n"
        );
        return array;
    };
    // assumes indices match
    // assumes mapping is for IDs
    XMLUtility.prototype.xmlMapping = function (oldIDs, newIDs) {
        var array = [];
        var index;
        for (index = 0; index < oldIDs.length; index++) {
            array.push(
                "<mapping>\n",
                "\t<old><id>" + oldIDs[index] + "</id></old>\n",
                "\t<new><id>" + newIDs[index] + "</id></new>\n",
                "</mapping>\n"
            );
        }
        return array;
    };
    XMLUtility.prototype.getName = function (component) {
        var name;
        if (component instanceof VesselModel) {
            name = component.get("vessel").name;
        }
        else if (component instanceof ToolModel) {
            if (component.get("tool").name === "Scale") {
                name = "scale";
            }
            else if (component.get("tool").name = "Bunsen_Burner") {
                name = "bunsen burner";
            }
            else {
                name = "tool";
            }
        }
        else {
            name = "component";
        }
        return name;
    };
    // shift every line over by 1 tab
    XMLUtility.prototype.tabify = function (array) {
        var result = [];
        var i;
        for (i = 0; i < array.length; i++) {
            var line = "\t";
            result.push(line.concat(array[i]));
        }
        return array;
    };
    XMLUtility.getInstance = function() {
        if(instance === null) {
            instance = new XMLUtility();
        }
        return instance;
    };
    return XMLUtility.getInstance();
});
